import { Loader } from './loader';
import 'jquery';

export function ajax(o) {
    o = typeof o === "undefined" ? {} : o;

    // set default values
    o.async = typeof o.async !== "undefined" ? o.async : true;
    o.callback = typeof o.callback !== "undefined" ? o.callback : null;
    o.contentType = typeof o.contentType !== "undefined" ? o.contentType : "application/json";
    o.data = typeof o.data !== "undefined" ? o.data : '';
    o.dataType = typeof o.dataType !== "undefined" ? o.dataType : 'json';
    o.hideLoader = typeof o.hideLoader !== "undefined" ? o.hideLoader : true;
    o.loaderMessage = typeof o.loaderMessage !== "undefined" ? o.loaderMessage : '';
    o.loaderUseOpaqueBackground = typeof o.loaderUseOpaqueBackground !== "undefined" ? o.loaderUseOpaqueBackground : false;
    o.params = typeof o.params !== "undefined" ? o.params : '';
    o.requestVerificationToken = typeof o.requestVerificationToken !== "undefined" ? o.requestVerificationToken : '';
    o.showLoader = typeof o.showLoader !== "undefined" ? o.showLoader : false;
    o.type = typeof o.type !== "undefined" ? o.type : 'POST';
    o.url = typeof o.url !== "undefined" ? o.url : '';

    // you can not use JSON.stringify on o.data if o.type == 'GET' so only add JSON.stringify() if post,
    // to make it possible to call with either post/get with a object or a get literal string
    if (o.type.toUpperCase() === 'POST') {
        o.data = JSON.stringify(o.data);
    }
    var returnObject  = {};

    if (o.url === '') {
        console.log('Unify ajax(): no url === no request', o);
        return returnObject;
    }

    if (o.showLoader === true) {
        var loader = new Loader();
        loader.show(o.loaderUseOpaqueBackground, o.loaderMessage);
    }

    var returnData  = null;
    var that = o;
    var promise  = $.ajax({
        url: o.url,
        type: o.type,
        async: o.async,
        data: o.data,
        dataType: o.dataType,
        contentType: o.contentType,
        success: function (data) {
            returnData = data;
            if (typeof (that.callback) !== 'undefined' && that.callback !== null) {
                that.callback(data, that.params);
            }
        },
        error: function (error) {
            console.log('error in Unify ajax() function:' + JSON.stringify(error));
        },
        complete: function () {
            if (that.showLoader && that.hideLoader) {
                var loader = new Loader();
                loader.hide();
            }
        },
        headers: function () {
            if (that.requestVerificationToken !== '') {
                return { 'RequestVerificationToken': that.requestVerificationToken };
            }
            return undefined;
        }
    });

    returnObject['promise'] = promise;
    if (o.async === false) {
        returnObject['data'] = returnData;
    } else {
        returnObject['data'] = undefined;
    }

    return returnObject;
}
